import { useState } from 'react';
import AuthRequiredPanel from './components/auth/AuthRequiredPanel';
import SiteFooter from './components/layout/SiteFooter';
import DesktopHeader from './components/navigation/DesktopHeader';
import MobileTabBar from './components/navigation/MobileTabBar';
import { useHashPath } from './hooks/useHashPath';
import HomePage from './pages/HomePage';
import IntroLanding from './pages/IntroLanding';
import MyPage from './pages/MyPage';
import NewsPage from './pages/NewsPage';
import PartnersPage from './pages/PartnersPage';
import ServicesPage from './pages/ServicesPage';
import SupportPage from './pages/SupportPage';
import { routeMap, routes } from './routes/routes';
import './App.css';

const pageComponents = {
  home: HomePage,
  services: ServicesPage,
  news: NewsPage,
  partners: PartnersPage,
  support: SupportPage,
  my: MyPage,
};

function App() {
  const currentPath = useHashPath();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  if (currentPath === routes.intro) {
    return <IntroLanding />;
  }

  const activeItem = routeMap[currentPath] ?? routeMap[routes.home];
  const ActivePage = pageComponents[activeItem.id] || HomePage;
  const canViewActivePage = !activeItem.authRequired || isAuthenticated;

  return (
    <div className="app-shell">
      <DesktopHeader
        activePath={activeItem.path}
        isAuthenticated={isAuthenticated}
        onAuthToggle={() => setIsAuthenticated((current) => !current)}
      />

      <main className="app-main">
        {canViewActivePage ? (
          <ActivePage isAuthenticated={isAuthenticated} />
        ) : (
          <AuthRequiredPanel
            pageLabel={activeItem.label}
            onLogin={() => setIsAuthenticated(true)}
          />
        )}
      </main>

      <SiteFooter />

      <MobileTabBar activePath={activeItem.path} />
    </div>
  );
}

export default App;
